/**
 * Free-text "link" fields (a selection option's Link, ...) are stored exactly as the user typed them:
 * the input never validates or blocks. SAFETY is applied where the value is OPENED: `toSafeHref`
 * returns an address a browser may navigate to, or null.
 *
 *   - only `http:` / `https:` addresses are ever returned (the scheme is checked on the PARSED url, so
 *     case tricks and embedded tabs/newlines cannot hide another one) -- `javascript:`, `data:`, `vbscript:`, `file:`,
 *     `mailto:` ... come back null, so a stored link can never execute code (XSS) or open a local file;
 *   - a value with no scheme ("www.example.com", "example.com/x", "example.com:8080") is opened as
 *     https://<value>; the stored value itself is never rewritten;
 *   - anything that is not a well-formed address ("see the supplier's site") returns null: it is shown
 *     as plain text and simply is not clickable.
 */

// "scheme:" -- but "host:8080" is a host with a port, not a scheme (a port starts with a digit).
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:(?!\d)/i;

export function toSafeHref(raw: string | null | undefined): string | null {
  const value = (raw ?? '').trim();
  if (!value) return null;
  const candidate = HAS_SCHEME.test(value) ? value : `https://${value.replace(/^\/\//, '')}`;
  try {
    const url = new URL(candidate);
    return url.protocol === 'http:' || url.protocol === 'https:' ? candidate : null;
  } catch {
    return null;
  }
}
